var _rect, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcPaymentJcb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 32,
    viewBox: "0 0 50 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.16602,
    y: 0.5,
    width: 45.6667,
    height: 31,
    rx: 5.5,
    fill: "white",
    stroke: "#E5E5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4241 16.3824C31.109 16.3973 31.7978 16.3521 32.48 16.4058C33.1708 16.5347 33.3373 17.5805 32.7236 17.9231C32.3048 18.1487 31.8073 18.0071 31.3533 18.0469H30.4241V16.3824ZM32.876 14.4984C33.0282 15.0355 32.5104 15.5177 31.9931 15.4437H30.4241C30.4351 14.9372 30.4026 14.3875 30.4401 13.9076C31.0686 13.9253 31.7029 13.8715 32.3278 13.9358C32.5963 14.0032 32.821 14.2239 32.876 14.4984ZM36.6519 6.53324C36.6811 7.55898 36.6562 8.63893 36.6645 9.68547C36.6626 13.9403 36.6686 18.1951 36.6612 22.4502C36.6337 24.0448 35.2205 25.4304 33.6369 25.4622C32.0518 25.4686 30.4664 25.4632 28.8811 25.465V19.0325C30.6084 19.0236 32.3366 19.0506 34.0631 19.019C34.8641 18.9687 35.7414 18.4402 35.7787 17.5588C35.873 16.6736 35.0384 16.0613 34.246 15.9645C33.9414 15.9566 33.9503 15.8758 34.246 15.8405C35.0018 15.6771 35.5953 14.8949 35.3729 14.1115C35.1834 13.2876 34.2727 12.9687 33.5153 12.9703C31.9708 12.9598 30.426 12.9688 28.8814 12.9658C28.8914 11.7649 28.8606 10.5627 28.898 9.36276C29.0204 7.79693 30.4692 6.50563 32.0305 6.53365C33.5712 6.53342 35.1116 6.53342 36.6519 6.53336V6.53324Z",
    fill: "url(#paint0_linear_1448_42688)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4278 9.52523C11.4672 7.93314 12.8865 6.55891 14.468 6.53564C16.0473 6.53078 17.6268 6.53494 19.206 6.53353C19.2017 11.8603 19.2146 17.1877 19.1995 22.5142C19.1387 24.0869 17.7349 25.4349 16.1706 25.4628C14.5884 25.4685 13.0059 25.4636 11.4236 25.4652V18.8159C12.9606 19.179 14.5723 19.3335 16.1402 19.0927C17.0775 18.9419 18.1029 18.4816 18.4202 17.5093C18.6537 16.6775 18.5223 15.8022 18.557 14.9485V12.9661H15.8435C15.8314 14.2772 15.8685 15.5907 15.8239 16.9003C15.7508 17.7052 14.9536 18.2166 14.1944 18.1893C13.2529 18.1993 11.3872 17.507 11.3872 17.507C11.3825 15.0504 11.4145 11.9739 11.4278 9.52546V9.52523Z",
    fill: "url(#paint1_linear_1448_42688)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2187 13.766C20.0759 13.7963 20.19 13.2795 20.1535 13.0834C20.1632 11.8438 20.1332 10.6029 20.1701 9.36413C20.2921 7.79168 21.752 6.49716 23.3197 6.53397H27.9362C27.9319 11.8607 27.9447 17.1881 27.9297 22.5146C27.8688 24.0873 26.4649 25.4353 24.9006 25.4632C23.3183 25.4692 21.7358 25.4642 20.1534 25.4657V18.1804C21.2341 19.0672 22.703 19.2052 24.0493 19.2076C25.0643 19.2072 26.0734 19.0507 27.0591 18.8167V17.482C25.9483 18.0356 24.6425 18.3873 23.4111 18.0692C22.5521 17.8554 21.9286 17.0252 21.9424 16.1388C21.8429 15.2169 22.3833 14.2436 23.2892 13.9695C24.414 13.6174 25.6399 13.8867 26.6942 14.3445C26.9201 14.4628 27.1494 14.6095 27.0591 14.2319V13.1829C25.2957 12.7633 23.4192 12.609 21.6476 13.0654C21.1349 13.21 20.6353 13.4294 20.2187 13.7661V13.766Z",
    fill: "url(#paint2_linear_1448_42688)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1448_42688",
    x1: 28.828,
    y1: 15.5943,
    x2: 36.6155,
    y2: 15.5943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B03A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55B330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1448_42688",
    x1: 11.2581,
    y1: 16.1807,
    x2: 19.0784,
    y2: 16.1807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F6EB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1448_42688",
    x1: 20.142,
    y1: 15.7784,
    x2: 27.9348,
    y2: 15.7784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30138"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPaymentJcb);
export default __webpack_public_path__ + "static/media/ic-payment-jcb.cafe2426efd6ba9da945b096d0a6c4af.svg";
export { ForwardRef as ReactComponent };